export default "__VITE_ASSET__DRdBaWmH__"